module.exports = __webpack_public_path__ + "static/media/drums-double-bass.34193f76.mp3";